module.exports = __webpack_public_path__ + "static/media/profile.0e734f93.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_menu_icons/profile.svg
// module id = 2714
// module chunks = 0